export const NAV_SCROLL_OFFSET = 96;

export function scrollToHash(hash, behavior = 'smooth') {
  if (!hash) return false;
  const id = hash.replace('#', '');
  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.scrollY - NAV_SCROLL_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}
